import React from "react";

const Game = (props) => {

  if (!props.game.topScores || props.game.topScores.length === 0) {
    return null;
  }

  return (
    <div className="bg-[#181f52] text-white rounded-xl p-6 w-full max-w-6xl mx-auto font-sans">
      <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
        <div className="flex flex-col items-center gap-6">
          <div className="text-2xl text-white text-center Kallisto_Bold">
            LEGEND SCORE
          </div>
          <div className="w-full max-w-xs flex items-center justify-between bg-white text-[#0a0e2c] rounded px-6 py-3 font-bold text-lg">
            <span>🏆</span>
            <span className="Kallisto_Bold">{props.game.legend.name}</span>
            <span className="text-2xl Kallisto_Bold">
              {props.game.legend.score}
            </span>
          </div>

          <div className="text-2xl text-white text-center Kallisto_Bold">
            TOP OF THE MONTH
          </div>
          <div className="w-full max-w-xs flex items-center justify-between bg-white text-[#0a0e2c] rounded px-6 py-3 font-bold text-lg">
            <span>🥇</span>
            <span className="Kallisto_Bold">{props.game.topOfMonth.name}</span>
            <span className="Kallisto_Bold text-2xl">
              {props.game.topOfMonth.score}
            </span>
          </div>

          <img
            className="mx-auto mt-6 w-[40%]"
            src={props.game.game.icon}
            alt="Run of Play"
          />
        </div>

        <div className="flex flex-col justify-start">
          <div className="text-2xl text-white text-center Kallisto_Bold mb-6">
            THIS WEEK'S TOP SCORES
          </div>

          <div className="space-y-2">
            {props.game.topScores.map((player, index) => (
              <div
                key={index}
                className="grid grid-cols-[25%_50%_25%] items-center bg-[#181f52] px-4 rounded-lg Kallisto_Bold"
              >
                <div className="text-2xl text-white">{player.position}ᵗʰ</div>
                <div
                  className="text-white text-left truncate pr-2"
                  title={player.name}
                >
                  {player.name}
                </div>
                <div className="text-white text-2xl text-right">
                  {player.score}
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Game;
